<template>
      <FullCalendar :events="dados" :options="options" />
</template>

<script>
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import moment from 'moment'

export default {
  name:"AgendaSerplag",
  props: {
    tituloAgenda: {
        // Especifica o titulo a ser exibido no cabeçalho da agenda
        type: String
    },
    dados: {
      // A coleção de dados que será renderizada na Agenda
      type: Array,
      required: true
    },
    onEventoSelecionado: {
      // Evento disparado quando seleciona o evento
      type: Function
    },
    dataAtual: {
      type: String,
      default: moment().format('L')
    }

  },      
    data: function(){
        return {
          eventos: [],
          exibirTela: false,
          modoEdicao: 'adicionar',
          options: {
            plugins:[dayGridPlugin, timeGridPlugin, interactionPlugin],
            defaultDate: this.dataAtual,
            aspectRatio: 2.4 ,       
            locale: 'pt-br',
            buttonText: {
              today:    'Hoje',
              month:    'Mês',
              week:     'Semana',
              day:      'Dia',
              list:     'Lista'
            },
            header: {
                left: 'prev,next',
                center: 'title',
                right: 'dayGridMonth,timeGridWeek,timeGridDay'
            },
            //editable: true,
            eventRender: this.displayDadosEvento,
            eventClick: this.eventoSelecionado
          },
        }
    },
    methods: {        
      displayDadosEvento(info){
        info.el.setAttribute('v-tooltip',info.event.extendedProps.description)
        
      
        //info.el.children.add(`v-tooltip="'Mensagem a Exibir'"`)
       /*  var tooltip = new Tooltip(info.el, {
          title: info.event.extendedProps.description,
          placement: 'top',
          trigger: 'hover',
          container: 'body'
        }); */
      },
      eventoSelecionado(info){
        // Verifica se trata o evento onEventoSelecionado()
        if (this.onEventoSelecionado){
          this.onEventoSelecionado(info.event)
        }
        // change the border color just for fun
        info.el.style.borderColor = 'red';
      }
    }
}
</script>

<style>

</style>